import React, { useEffect, useId, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { API } from "../../Utility/API";
import { updateAuth, updateStatus } from "../../Redux/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import DOMPurify from "dompurify";
import logo from "../../Assets/Images/logo.png";
import { Eye, EyeOff } from "lucide-react";
export default function Registration() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [sponsorid, setsponsorid] = useState();
  const history = useNavigate();
  const dispatch = useDispatch();
  const [checkbox, setcheckbox] = useState(false);
  const [spinnerload, setspinnerload] = useState(false);

  // const [sponsorid, setsponsorid] = useState("");
  const [sponsoruername, setsponsoruername] = useState("");
  const [sponsorname, setsponsorname] = useState("");
  const [username, setusername] = useState("");
  const [Accountaddresscheck, setAccountaddresscheck] = useState("");
  const [Accountaddress, setAccountaddress] = useState("");
  const [usernamecheck, setusernamecheck] = useState("");
  const [name, setname] = useState("");
  const [mobileNo, setmobileNo] = useState("");
  const [Emailid, setEmailid] = useState("");
  const [Password, setPassword] = useState("");
  const [Cpassword, setCpassword] = useState("");
  const [otp, setotp] = useState("");

  const [Postion, setSelectedPostion] = useState("");

  const [MobileCode, setMobileCode] = useState(0);
  const [valid, setValid] = useState(true);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryID, setcountryID] = useState("99");
  const [countryName, setcountryName] = useState("India");
  const [countryCode, setcountryCode] = useState("+91");
  const [stateList, setstateList] = useState([]);
  const [stateNewList, setstateNewList] = useState("");
  const [districtList, setdistrictList] = useState([]);
  const [districtNewList, setdistrictNewList] = useState("");
  const [pincode, setpincode] = useState("");
  const [showTextbox, setShowTextbox] = useState(false);
  const getresponseId = async (e) => {
    // let newValue = e.target.value;
    let { value } = e.target;
    const newValue = value.replace(/[^0-9]/gi, "");
    if (newValue === "") {
      setsponsorid("");
      setsponsorname("");
    } else {
      setsponsoruername(newValue);
      setsponsorid(newValue);
      let res = await API.get(`/check_sponsorid?uid=${newValue}`);

      if (res.data.data.result === "Sponsor Id doesnot exists !!") {
        setsponsorname("Wrong sponser id");
      } else {
        // let { f_name } = res.data.data[0];
        setsponsorname(res.data.data.result);
      }
    }
  };

  const checkOTP = async (e) => {
    let { value } = e.target;

    const newValue = value.replace(/[^0-9]/gi, "");

    if (newValue === "") {
      setotp("");
    } else {
      setotp(newValue);
    }
  };

  const checkUserName = async (e) => {
    let { value } = e.target;
    const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    //let newValue = e.target.value;
    //const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    if (newValue === "") {
      setusername("");
      setusernamecheck("");
    } else {
      setusername(newValue);
      let res = await API.get(`/check_Username?Username=${newValue}`);

      if (res.data.data.result === "User Allready Exist !!") {
        setusernamecheck("User Allready Exist");
      } else {
        // let { f_name } = res.data.data[0];
        setusernamecheck("Valid");
      }
    }
  };

  const checkAccountaddress = async (e) => {
    let { value } = e.target;
    const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    //let newValue = e.target.value;
    //const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    if (newValue === "") {
      setAccountaddress("");
    } else {
      setAccountaddress(newValue);
      let res = await API.get(`/check_address?address=${newValue}`);

      if (res.data.data.result === "Address is bnb Address") {
        setAccountaddresscheck("Valid");
      } else {
        setAccountaddresscheck("Invalid Address");
      }
    }
  };

  // const checkUserName = async (e) => {
  //   let { value } = e.target;

  //   const newValue = value.replace(/[^A-Z a-z]/g, "");

  //   if (newValue === "") {
  //     setusername("");
  //   } else {
  //     setusername(newValue);
  //   }
  // };

  const checkName = async (e) => {
    let { value } = e.target;
    //const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    const newValue = value.replace(/[^A-Z a-z]/g, "");

    if (newValue === "") {
      setname("");
    } else {
      setname(newValue);
    }
  };

  const District_name = async (e) => {
    let { value } = e.target;
    //const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    const newValue = value.replace(/[^A-Z a-z]/g, "");

    if (newValue === "") {
      setdistrictNewList("");
    } else {
      setdistrictNewList(newValue);
    }
  };

  const checkpin = async (e) => {
    let { value } = e.target;
    //const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    const newValue = value;
    if (newValue === "") {
      setpincode("");
    } else {
      setpincode(newValue);
    }
  };
  const checkCountry = async (e) => {
    // let { value } = e.target;

    // const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    let newValue = e.target.value;
    // const newValue = value.replace(/[^A-Za-z0-9]/g, "");
    if (newValue === "") {
      setcountryID("");
      setcountryName("");
      setcountryCode("");
      setstateList([]);
      setdistrictList([]);
    } else {
      let res = await API.get(`/GetcountrybyID?id=${newValue}`);
      setcountryID(res.data.data[0][0].id);
      setcountryName(res.data.data[0][0].name);
      setcountryCode(res.data.data[0][0].phonecode);
      StateList_API(newValue);
    }
  };

  const checkState = async (e) => {
    let newValue = e.target.value;
    if (newValue === "") {
      // profileData?.stateId
      setstateNewList(0);
    } else {
      setstateNewList(newValue);

      //setstateNewname(e.target.name);
      DistrictList_API(newValue);
    }
  };

  const checkDistrict = async (e) => {
    let newValue = e.target.value;
    if (newValue === "") {
      // profileData?.districtid
      setdistrictNewList(0);
    } else {
      setdistrictNewList(newValue);
    }
  };

  const StateList_API = async (CountryId) => {
    //  console.log("CountryId",CountryId)
    try {
      let response = await API?.post("getregion2", {
        regiontype: "State",
        regionid: CountryId,
      });
      //  console.log("responseCountryId-->",CountryId, response.data.data[0]);
      const fetchedStates = response.data.data[0];
      setstateList(fetchedStates);
    } catch (error) {
      //console.log("Country API ERROR", error);
    }
  };

  const DistrictList_API = async (stateId) => {
    try {
      let response = await API?.post("getregion2", {
        regiontype: "District",
        regionid: stateId,
      });
      //console.log("response-->", response.data.data[0]);
      const fetchedStates = response.data.data[0];
      setdistrictList(fetchedStates);
      if (fetchedStates.length == 0) {
        setShowTextbox(true);
      } else {
        setShowTextbox(false);
      }
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };

  const [otp_flag, setotp_flag] = useState(false);
  // console.log("otp_flag", otp_flag);

  const sendOTP = async () => {
    try {
      if (!valid) {
        toast.error("Please enter a valid email address");
        return;
      } else if (!Emailid) {
        toast.error("Please enter email address");
        return;
      }
      let res = await API.post("/RegistrationOtp", {
        Email: Emailid,
      });
      console.log("resopt", res);
      if (res.data.data === "Successfull") {
        setotp_flag(true);
        toast.success("OTP sent successfully!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const RegistrationAPI = async () => {
    setspinnerload(true);

    try {
      // const selectedCountryDetails = countries.find(
      //   (country) => country.name === selectedCountry
      // );

      // if (!selectedCountryDetails) {
      //   toast.error("Please select a valid country");
      //   return;
      // }
      if (!sponsoruername) {
        toast.error("Sponsor ID is required");
        return;
      } else if (sponsoruername.length > 15) {
        toast.error("Sponsor Id should not be greater than 15 characters");
        return;
      } else if (!name) {
        toast.error("First Name is required");
        return;
      } else if (name.length < 4) {
        toast.error("First Name must be at least 4 characters");
        return;
      } else if (name.length > 20) {
        toast.error("First Name should not be greater than 20 characters");
        return;
      } else if (!countryID) {
        toast.error("Country is required");
        return;
      } else if (!stateNewList) {
        toast.error("State is required");
        return;
      } else if (!districtNewList) {
        toast.error("District is required");
        return;
      } else if (!pincode) {
        toast.error("Pincode is required");
        return;
      } else if (mobileNo.length <= 9) {
        toast.error("Enter Valid Mobile Number !!");
        return;
      } else if (!valid) {
        toast.error("Please enter a valid email address");
        return;
      } else if (!Emailid) {
        toast.error("Please enter email address");
        return;
      } else if (!Password) {
        toast.error("Password is required");
        return;
      } else if (!Postion) {
        toast.error("position is required");
        return;
      } else if (Password.length < 6) {
        toast.error("Password must be at least 6 characters");
        return;
      } else if (Password != Cpassword) {
        toast.error("Confirm Password is not match");
        return;
      }
      //  else if (checkbox != true) {
      //   toast.error("Select Terms and Conditions");
      //   return;
      // }
      else if (!otp || otp.length !== 6) {
        toast.error("Please enter a valid OTP");
        return;
      } 
      let res = await API.post("/registration", {
        sponser_id: sponsoruername,
        f_name: name,
        email: Emailid,
        psw: Password,
        mob: mobileNo,
        counrtyid: countryID,
        countryName: countryName,
        otp: otp,
        position: Postion,
        originpassword: Password,
        stateName: stateNewList,
        DistrictName: districtNewList,
        pincode: pincode,
      });

      console.log("resregstrtion", res);

      console.log("resresult", res.data.data.result);
      if (res.data.data.result === "Successfull") {
        sessionStorage.setItem("Name", username);
        sessionStorage.setItem("Password", Password);
        toast.success(`Successfull`);
        let uid = res.data.data.uid_output;
        history(`/WelcomePage?userid=${uid}`);
      } else {
        toast.error(`${res.data.data.result}`);
        setspinnerload(false);
      }
      setspinnerload(false);
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const Mobile_Data = (event) => {
    const newValue = event.target.value.replace(/[^0-9]/gi, "");
    setmobileNo(newValue);
  };

  const EmailValidation = (event) => {
    const inputValue = event.target.value;
    setEmailid(inputValue);

    if (inputValue) {
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailRegex = /^[^\s@]{3,}@[^\s@]+\.[^\s@]+$/;
      const isValid = emailRegex.test(inputValue);
      setValid(isValid);
    } else {
      setValid(true);
    }
  };

  const ReferralAddress = async () => {
    try {
      let URL = window.location.href;
      let URL_ID = new URLSearchParams(window.location.search).get("userid");
      let URL_POS = new URLSearchParams(window.location.search).get("position");

      if (URL.includes("userid")) {
        setsponsoruername(URL_ID);
        setsponsorid(URL_ID);
        let res = await API.get(`/check_sponsorid?uid=${URL_ID}`);

        if (res.data.data.result === "Sponsor Id doesnot exists !!") {
          setsponsorname("Wrong sponser id");
        } else {
          // let { f_name } = res.data.data[0];
          setsponsorname(res.data.data.result);
        }
      }
      if (URL.includes("position")) {
        setSelectedPostion(URL_POS);
      } else {
        setSelectedPostion(0);
      }
    } catch (e) {
      console.log("Erroe Whille Referral Fuction Call", e);
    }
  };

  const CountryList_API = async () => {
    try {
      let res = await API.get("countryList");
      // console.log("country-->", res.data.data[0]);
      const fetchedCountries = res.data.data[0];
      setCountries(fetchedCountries);
      if (fetchedCountries[98]) {
        setSelectedCountry(fetchedCountries[98].name);
        setMobileCode(fetchedCountries[98].phonecode);
      }
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };

  useEffect(() => {
    CountryList_API();
    ReferralAddress();
  }, []);

  function handleSid(e) {
    const inputText = e.target.value.replace(/[^0-9]/gi, "").substring(0, 8);
    console.log("inputtext", inputText);
    const sanitizedInput = DOMPurify.sanitize(inputText);
    setsponsorid(sanitizedInput);
  }

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const [showPasswordCNF, setShowPasswordCNF] = useState(false);
  const togglePasswordVisibilityCNF = () => {
    setShowPasswordCNF((prev) => !prev);
  };

  return (
    <>
      <div className="container-fluid loginpage loginpage1 vhUnstet">
        <div className="row  align-items-center">
          <div className="col-md-4 col-sm-6 col-12 h-100 pt-md-5 mx-auto d-flex align-items-center justify-content-center flex-column">
            <div className="">
              <div className="card cardlogin py-4">
                <div className="card-body p-0">
                  <div className="row mx-0 align-items-center justify-content-center gy-3">
                    <div className="col-12">
                      <div className="loginheading text-center">
                        <img src={logo} />
                      </div>
                      <div className="subtext text-center">Register</div>
                    </div>

                    <div className="col-12">
                      {/* <input
                        type="text"
                        placeholder="Enter the account id or BNB Address"
                        className="control-form"
                        value={LoginId}
                        readOnly
                      /> */}
                      <input
                        type="text"
                        className="control-form"
                        name="sponser_id"
                        placeholder="Enter Sponsor Id"
                        required="required"
                        maxLength={15}
                        value={sponsorid}
                        onChange={(e) => {
                          getresponseId(e);
                        }}
                      />
                    </div>
                    <div className="col-12 d-flex gap-1">
                      <div className="col-6">
                        <input
                          type="text"
                          className={`control-form ${
                            sponsorname === "Wrong sponser id"
                              ? "text-danger"
                              : "text-success"
                          }`}
                          name="sponsername"
                          required="required"
                          placeholder="Sponsor Name"
                          readOnly="true"
                          value={sponsorname}
                          disabled={true}
                        />
                      </div>

                      <div className="col-6">
                        <select
                          id="Position"
                          name="position"
                          className="control-form w-100"
                          placeholder="Select Position"
                          value={Postion}
                          onChange={(e) => setSelectedPostion(e.target.value)}
                        >
                          <option value="" disable>
                            Select Position
                          </option>
                          <option value="1">Left</option>
                          <option value="2">Right</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-12">
                      <input
                        type="text"
                        className="control-form"
                        name="name"
                        required="required"
                        placeholder="Name"
                        maxLength={20}
                        value={name}
                        onChange={(e) => {
                          checkName(e);
                        }}
                      />
                    </div>
                    <div className="col-12">
                      <input
                        type="email"
                        className="control-form"
                        name="email"
                        required="required"
                        placeholder="example@gmail.com"
                        maxLength={50}
                        value={Emailid}
                        onChange={EmailValidation}
                      />
                    </div>
                    {Emailid && (
                      <>
                        <div className="col-12">
                          <button
                            onClick={sendOTP}
                            disabled={!Emailid || !valid}
                            className="btn btn-theme1 logibtn w-auto mx-auto d-flex justify-content-center px-5"
                          >
                            Send OTP
                          </button>
                        </div>
                        <div className="col-12">
                          <input
                            type="text"
                            className="control-form"
                            name="OTP"
                            required="required"
                            placeholder="Enter OTP"
                            maxLength={6}
                            value={otp}
                            onChange={checkOTP}
                          />
                        </div>
                      </>
                    )}
                    <div className="col-12">
                      <select
                        id="country"
                        name="country"
                        className="control-form"
                        value={countryID}
                        onChange={(e) => {
                          checkCountry(e);
                        }}
                        // onChange={(e) => setSelectedCountry(e.target.value)}
                      >
                        <option value="" disabled>
                          Select Country
                        </option>
                        {countries.map((country, index) => (
                          <option key={index} value={country.id}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      <select
                        id="state"
                        name="state"
                        className="control-form"
                        value={stateNewList}
                        onChange={(e) => {
                          checkState(e);
                        }}
                      >
                        <option value="" disabled>
                          Select State
                        </option>
                        {stateList?.map((state, index) => (
                          <option
                            key={index}
                            value={state?.id}
                            name={state?.name}
                          >
                            {state?.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      {/* <label htmlFor="email">District:</label>
                      <select
                        id="district"
                        name="district"
                        class="form-control countryselect"
                        value={districtNewList}
                        onChange={(e) => {
                          checkDistrict(e);
                        }}
                      >
                        <option value="" disabled>
                          Select District
                        </option>
                        {districtList.map((dis, index) => (
                          <option key={index} value={dis?.id}>
                            {dis?.name}
                          </option>
                        ))}
                      </select> */}

                      {!showTextbox ? (
                        <>
                          <label htmlFor="email">District:</label>
                          <select
                            id="district"
                            name="district"
                            class="form-control countryselect"
                            value={districtNewList}
                            onChange={(e) => {
                              checkDistrict(e);
                            }}
                          >
                            <option value="" disabled>
                              Select District
                            </option>
                            {districtList.map((dis, index) => (
                              <option key={index} value={dis?.id}>
                                {dis?.name}
                              </option>
                            ))}
                          </select>
                        </>
                      ) : (
                        showTextbox && (
                          <>
                            <label className="block mb-2 font-bold">
                              Enter district name:
                            </label>
                            <input
                              type="text"
                            className="control-form"
                            value={districtNewList}
                        onChange={(e) => {
                          District_name(e);
                        }}
                              placeholder="Type district name..."

                            />
                          </>
                        )
                      )}
                    </div>
                    <div className="col-12">
                      <label htmlFor="pincode">Pin:</label>
                      <input
                        type="text"
                        id="pincode"
                        className="control-form"
                        placeholder="Enter Pin"
                        value={pincode}
                        onChange={(e) => {
                          checkpin(e);
                        }}
                        maxLength={6}
                      />
                    </div>
                    <div className="col-12 d-flex">
                      <div className="col-4 px-0">
                        <input
                          type="text"
                          required="required"
                          className="control-form"
                          placeholder="Country Code"
                          readOnly
                          value={countryCode}
                          maxLength={12}
                        />
                      </div>
                      <div className="col-8 px-0">
                        <input
                          type="text"
                          required="required"
                          className="control-form"
                          placeholder="Mobile Number"
                          value={mobileNo}
                          onChange={Mobile_Data}
                          maxLength={12}
                        />
                      </div>
                    </div>
                    <div className="col-12 d-flex">
                      <div className="col-11">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="control-form regpassinp"
                          name="password"
                          required="required"
                          placeholder="Enter Password"
                          maxLength={20}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        />
                      </div>
                      <div className="col-1">
                        <button
                          type="button"
                          className="absolute eyebtn right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                          onClick={togglePasswordVisibility}
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                        >
                          {showPassword ? (
                            <EyeOff size={15} />
                          ) : (
                            <Eye size={15} />
                          )}
                        </button>
                      </div>
                    </div>
                    <div className="col-12 d-flex">
                      <div className="col-11">
                        <input
                          type={showPasswordCNF ? "text" : "password"}
                          className="control-form confregpassinp"
                          name="confpassword"
                          required="required"
                          placeholder="Confirm Password"
                          maxLength={20}
                          onChange={(e) => {
                            setCpassword(e.target.value);
                          }}
                        />
                      </div>

                      <div className="col-1">
                        <button
                          type="button"
                          className="absolute eyebtn right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                          onClick={togglePasswordVisibilityCNF}
                          aria-label={
                            showPasswordCNF ? "Hide password" : "Show password"
                          }
                        >
                          {showPasswordCNF ? (
                            <EyeOff size={15} />
                          ) : (
                            <Eye size={15} />
                          )}
                        </button>
                        {/* <span className="position-absolute eye">
                          <i className="fa fa-eye text-black eye" />
                        </span> */}
                      </div>
                    </div>
                    <div className="col-12">
                      {otp_flag && (
                        <button
                          onClick={RegistrationAPI}
                          disabled={!otp || otp.length !== 6}
                          className="btn btn-theme1 logibtn w-auto mx-auto d-flex justify-content-center px-5"
                        >
                          Register
                        </button>
                      )}
                    </div>

                    {/* <div className="col-12">
                      <button
                        // onClick={() => setregistor_Model(true)}
                        className="btn btn-theme1 logibtn w-auto mx-auto d-flex justify-content-center px-5">
                        Register
                      </button>
                    </div> */}
                    <div className="col-12 ">
                      <div className="remembertext2 text-center">
                        If you have already registered then{" "}
                        <Link
                          className="Anker btn btn-theme1 logibtn  px-5"
                          to="/login"
                        >
                          Login
                        </Link>
                      </div>
                      <div className="remembertext2 text-center mb-3">
                        Copyright © 2024. All Rights Reserved.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
